import {FeatureFlagConfig, FeatureFlagParams, AllowedKeys, ConfigurationName} from './../types'
import {useFeatureFlag} from './useFeatureFlag'

type CommonFeatureFlagKey = AllowedKeys<FeatureFlagConfig.Common>

type ParamsForCommonKey<K extends CommonFeatureFlagKey> = K extends keyof FeatureFlagParams
  ? FeatureFlagParams[K]
  : undefined

type FeatureFlagParamsArg<C extends ConfigurationName, K extends AllowedKeys<C>> = Parameters<
  typeof useFeatureFlag<C, K>
>[2]

export function useCommonFeatureFlag<K extends CommonFeatureFlagKey>(
  key: K,
  params?: ParamsForCommonKey<K>
): boolean | undefined {
  return useFeatureFlag(
    FeatureFlagConfig.Common,
    key,
    params as FeatureFlagParamsArg<FeatureFlagConfig.Common, K>
  )
}
